// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"e58c2961","71":"4aee1e75","79":"ddab5fba","86":"6a017f9e","153":"dc12adf6","237":"684b15ab","440":"bcc4ef8d","484":"a54e6588","525":"5ec74e79","570":"e4fec8d1","619":"46873254","621":"3a57021a","664":"15b82240","695":"35c9b727","894":"1bc05b06"}[chunkId] + ".chunk.js";
};